import * as React from 'react';

import { Typography } from 'components';
import { useStyles } from './TextRow.styles';
import clsx from "clsx";

type TextRowProps = {
  title?: string;
  subtitle?: string;
  text?: string | JSX.Element;
  subtext?: string;
};

const TextRow: React.FC<TextRowProps> = ({ title, subtitle, text, subtext }) => {
  const styles = useStyles();

  const titleClasses = clsx(styles.title, text ? styles.justified : styles.centered);
  const textType = text ? "text" : "hint";
  const align = text ?  "left" : "center";

  return (
    <section>
      {title &&
        <section className={titleClasses}>
          <Typography textColor="black" textType={textType} align={align}>
            {title}
          </Typography>
          {text && <Typography textColor="black" textType="text">
            {text}
          </Typography>}
        </section>
      }
      {subtitle &&
        <section className={styles.subtitle}>
          <Typography textColor="grey" textType="hint">
            {subtitle}
          </Typography>
          <Typography textColor="grey" textType="hint">
            {subtext}
          </Typography>
        </section>
      }
    </section>
  );
};

export default TextRow;
